import addEventListenerMultiType from "../common/multiEventLister.js";

addEventListenerMultiType(document, "mouseover click", (e) => {
  if ( e.target.getAttribute("data-event-id")) {
    let id = e.target.getAttribute("data-event-id");
    removeActive();
    AddMatchId(id);
  } else {
    removeActive();
  }
});

function AddMatchId(id) {
  $('[data-event-id="'+id+'"]').addClass('-hover-active');
}

function removeActive() {
  $('[data-event-id]').removeClass('-hover-active');
}